import { ILeader } from "@/lib/community";
import { ChevronDown, Trophy } from "lucide-react";
import { useUserWeekRatings } from "@/hooks/useUserRatings";
import { LeaderRow } from "./LeaderRow";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

function SkeletonRow() {
  return (
    <div className="flex items-center gap-2 md:gap-3 py-1.5 md:py-2 px-2 animate-pulse">
      <div className="w-6 h-6 md:w-7 md:h-7 rounded bg-gray-200" />
      <div
        className="rounded-full bg-gray-200"
        style={{ width: 32, height: 32 }}
      />
      <div className="flex-1 min-w-0 ml-2">
        <div className="h-3.5 md:h-4 rounded bg-gray-200 mb-1 w-2/4" />
        <div className="h-2.5 md:h-3 rounded bg-gray-100 w-1/3" />
      </div>
      <div className="h-4 md:h-5 rounded bg-gray-200 w-8 md:w-10" />
    </div>
  );
}

function LeaderBoardCardContent() {
  const { t } = useTranslation();
  const { week } = useUserWeekRatings();
  const { data } = week;
  const renderList = (list: ILeader[]) => (
    <ol className="mt-2 space-y-2 md:space-y-3">
      {list.map((user, i) => (
        <LeaderRow key={user.user_id} user={user} index={i} />
      ))}
    </ol>
  );

  return (
    <>
      <h2 className="font-semibold mb-3 md:mb-4 text-base md:text-xl text-gray-800 flex items-center gap-2 dark:text-white">
        <Trophy className="w-5 h-5 md:w-6 md:h-6 text-blue-400" />
        {t("community.leaderBoardCard.title")}
      </h2>
      {week.isLoading ? (
        <div className="space-y-1.5 md:space-y-2">
          {Array.from({ length: 5 }).map((_, idx) => (
            <SkeletonRow key={idx} />
          ))}
        </div>
      ) : week.error ? (
        <div className="text-red-500 text-center">
          {t("community.leaderBoardCard.error")}
        </div>
      ) : (
        <>
          <div className="block md:hidden">
            {renderList(data!.slice(0, 3))}
            <Link
              to={"/leaderboard"}
              className="mt-2 w-full flex items-center justify-center gap-1 text-xs text-blue-600 rounded bg-blue-50 hover:bg-blue-100 py-1.5 font-medium transition"
            >
              {t("community.leaderBoardCard.showAll")}
              <ChevronDown size={16} />
            </Link>
          </div>
          <div className="hidden md:block">{renderList(data!)}</div>
        </>
      )}
      <hr className="mt-4" />
      <div className="flex justify-center">
        <Link
          to={"/leaderboard"}
          className="w-full hidden md:flex items-center justify-center gap-1 text-xs text-blue-600 rounded py-1.5 font-medium transition"
        >
          {t("community.leaderBoardCard.showAll")}
        </Link>
      </div>
    </>
  );
}

export default LeaderBoardCardContent;
